import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useJobDescriptionsFromExternalWebsitesState() {
  return useAppState();
}

export function useJobDescriptionsFromExternalWebsitesActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      jobDescriptionsFromExternalWebsites: [],
      pageNumber: 1,
      numberOfPages: 1,
      updateJobDescriptionFromExternalWebsiteModalIsOpen: false,
      updateJobDescriptionFromExternalWebsite: {
        jobDescriptionFromExternalWebsiteId: '',
        title: '',
      },
      closeJobDescriptionFromExternalWebsiteModalIsOpen: false,
      closeJobDescriptionFromExternalWebsite: {
        jobDescriptionFromExternalWebsiteId: '',
      },
      reopenJobDescriptionFromExternalWebsiteModalIsOpen: false,
      reopenJobDescriptionFromExternalWebsite: {
        jobDescriptionFromExternalWebsiteId: '',
      },
      deleteJobDescriptionFromExternalWebsiteModalIsOpen: false,
      deleteJobDescriptionFromExternalWebsite: {
        jobDescriptionFromExternalWebsiteId: '',
      },
      archiveJobDescriptionFromExternalWebsiteModalIsOpen: false,
      archiveJobDescriptionFromExternalWebsite: {
        jobDescriptionFromExternalWebsiteId: '',
      },
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function updateJobDescriptionFromExternalWebsiteFormTitle(title) {
    dispatch((appState) => ({
      ...appState,
      updateJobDescriptionFromExternalWebsite: {
        ...appState.updateJobDescriptionFromExternalWebsite,
        title: title,
      },
    }));
  }

  function openUpdateJobDescriptionFromExternalWebsiteModal(jobDescription) {
    dispatch((appState) => ({
      ...appState,
      updateJobDescriptionFromExternalWebsiteModalIsOpen: true,
      updateJobDescriptionFromExternalWebsite: {
        ...appState.updateJobDescriptionFromExternalWebsite,
        jobDescriptionFromExternalWebsiteId: jobDescription.id,
        title: jobDescription.title,
      },
    }));
  }

  function closeUpdateJobDescriptionFromExternalWebsiteModal() {
    dispatch((appState) => ({
      ...appState,
      updateJobDescriptionFromExternalWebsiteModalIsOpen: false,
      updateJobDescriptionFromExternalWebsite: {
        jobDescriptionFromExternalWebsiteId: '',
        title: '',
      },
    }));
  }

  function openCloseJobDescriptionFromExternalWebsiteModal(jobDescription) {
    dispatch((appState) => ({
      ...appState,
      closeJobDescriptionFromExternalWebsiteModalIsOpen: true,
      closeJobDescriptionFromExternalWebsite: {
        ...appState.closeJobDescriptionFromExternalWebsite,
        jobDescriptionFromExternalWebsiteId: jobDescription.id,
      },
    }));
  }

  function closeCloseJobDescriptionFromExternalWebsiteModal() {
    dispatch((appState) => ({
      ...appState,
      closeJobDescriptionFromExternalWebsiteModalIsOpen: false,
      closeJobDescriptionFromExternalWebsite: {
        jobDescriptionFromExternalWebsiteId: '',
      },
    }));
  }

  function openReopenJobDescriptionFromExternalWebsiteModal(jobDescription) {
    dispatch((appState) => ({
      ...appState,
      reopenJobDescriptionFromExternalWebsiteModalIsOpen: true,
      reopenJobDescriptionFromExternalWebsite: {
        ...appState.reopenJobDescriptionFromExternalWebsite,
        jobDescriptionFromExternalWebsiteId: jobDescription.id,
      },
    }));
  }

  function closeReopenJobDescriptionFromExternalWebsiteModal() {
    dispatch((appState) => ({
      ...appState,
      reopenJobDescriptionFromExternalWebsiteModalIsOpen: false,
      reopenJobDescriptionFromExternalWebsite: {
        jobDescriptionFromExternalWebsiteId: '',
      },
    }));
  }

  function openDeleteJobDescriptionFromExternalWebsiteModal(jobDescription) {
    dispatch((appState) => ({
      ...appState,
      deleteJobDescriptionFromExternalWebsiteModalIsOpen: true,
      deleteJobDescriptionFromExternalWebsite: {
        ...appState.deleteJobDescriptionFromExternalWebsite,
        jobDescriptionFromExternalWebsiteId: jobDescription.id,
      },
    }));
  }

  function closeDeleteJobDescriptionFromExternalWebsiteModal() {
    dispatch((appState) => ({
      ...appState,
      deleteJobDescriptionFromExternalWebsiteModalIsOpen: false,
      deleteJobDescriptionFromExternalWebsite: {
        jobDescriptionFromExternalWebsiteId: '',
      },
    }));
  }

  function openArchiveJobDescriptionFromExternalWebsiteModal(jobDescription) {
    dispatch((appState) => ({
      ...appState,
      archiveJobDescriptionFromExternalWebsiteModalIsOpen: true,
      archiveJobDescriptionFromExternalWebsite: {
        ...appState.archiveJobDescriptionFromExternalWebsite,
        jobDescriptionFromExternalWebsiteId: jobDescription.id,
      },
    }));
  }

  function closeArchiveJobDescriptionFromExternalWebsiteModal() {
    dispatch((appState) => ({
      ...appState,
      archiveJobDescriptionFromExternalWebsiteModalIsOpen: false,
      archiveJobDescriptionFromExternalWebsite: {
        jobDescriptionFromExternalWebsiteId: '',
      },
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    updateJobDescriptionFromExternalWebsiteFormTitle,
    openUpdateJobDescriptionFromExternalWebsiteModal,
    closeUpdateJobDescriptionFromExternalWebsiteModal,
    openCloseJobDescriptionFromExternalWebsiteModal,
    closeCloseJobDescriptionFromExternalWebsiteModal,
    openReopenJobDescriptionFromExternalWebsiteModal,
    closeReopenJobDescriptionFromExternalWebsiteModal,
    openDeleteJobDescriptionFromExternalWebsiteModal,
    closeDeleteJobDescriptionFromExternalWebsiteModal,
    openArchiveJobDescriptionFromExternalWebsiteModal,
    closeArchiveJobDescriptionFromExternalWebsiteModal,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
